import {RoutesConfig, PrivateRoute, BaseRoute, ProfileConnectRoute} from '../external-components';
import Authenticate from '../pages/Authenticate';
import LandingPage from '../pages/LandingPage';
import ProfileConnectRedirect from '../pages/ProfileConnectRedirect';
import Logout from '../pages/Logout';
import {AppErrorPage, GaasConfirmationPage} from '@gaas/gaas-react-component-library';
import EligibilityPage from 'src/pages/P10.GaasEligibilityPage'
import SupportingDocumentsPage from 'src/pages/P30.SupportingDocumentsPage';
import ReviewPage from 'src/pages/P50.ReviewPage';
import TermsConditionsTr3Page from 'src/pages/TermsConditionsTr3';

import config from '../config/config';
import P01ManageTollAccount from '../pages/P01.ManageTollAccount';
import P20SoleTraderTollAccountDetailsPage from '../pages/P20.SoleTraderTollAccountDetailsPage';
import P20PersonalTollAccountDetailsPage from '../pages/P20.PersonalTollAccountDetailsPage';
import P30SoleTraderBusinessDetailsPage from '../pages/P30.SoleTraderBusinessDetailsPage';
import UnableToProcessRequest from '../pages/UnableToProcessRequest';
import PreferredNameErrorPage from '../pages/PreferredNameErrorPage';

export const routes: RoutesConfig = {
    manageTollAccount: {
        component: P01ManageTollAccount,
        title: 'Manage Toll Account | ' + config.appTitle,
        route: PrivateRoute,
        path: '/manage-toll-account',
    },
    // TODO remove this after Tr2 decom
    tr3TermsConditionsPage: {
        component: TermsConditionsTr3Page,
        title: 'New Toll Relief Rebate Scheme | ' + config.appTitle,
        route: ProfileConnectRoute,
        path: '/terms-conditions-tr3'
    },
    personalTollAccountDetails: {
        component: P20PersonalTollAccountDetailsPage,
        title: `Link Personal Toll Account | ${config.appTitle}`,
        route: ProfileConnectRoute,
        path: '/personal-toll-account-details',
    },
    // TODO remove this after Tr2 decom
    businessTollAccountDetails: {
        component: P20SoleTraderTollAccountDetailsPage,
        title: `Link Business Toll Account | ${config.appTitle}`,
        route: ProfileConnectRoute,
        path: '/business-toll-account-details',
    },
    // TODO remove this after Tr2 decom
    mixedTollAccountDetails: {
        component: P20SoleTraderTollAccountDetailsPage,
        title: `Link Mixed Toll Account | ${config.appTitle}`,
        route: ProfileConnectRoute,
        path: '/mixed-toll-account-details',
    },
    // TODO remove this after Tr2 decom
    supportingDocumentsPage: {
        component: SupportingDocumentsPage,
        title: 'Supporting Documents | ' + config.appTitle,
        route: ProfileConnectRoute,
        path: '/supporting-documents-page',
    },
    // TODO remove this after Tr2 decom
    soleTraderBusinessDetails: {
        component: P30SoleTraderBusinessDetailsPage,
        title: `Sole Trader Details | ${config.appTitle}`,
        route: ProfileConnectRoute,
        path: '/sole-trader-business-details',
    },
    // Routes included in progress stepper
    eligibilityPage: {
        component: EligibilityPage,
        title: 'Eligibility | ' + config.appTitle,
        //pageHeading: 'Eligibility',
        route: ProfileConnectRoute,
        //stepIndex: stepIndex++,
        // Example of how to disable Session Timeout on specific pages
        sessionTimeoutEnabled: false,
        path: '/eligibility-page'
        // exact: true
    },
    // TODO remove this after Tr2 decom
    ReviewPage: {
        component: ReviewPage,
        title: 'Review | ' + config.appTitle,
        //pageHeading: 'Review',
        route: ProfileConnectRoute,
        //stepIndex: stepIndex++,
        path: '/review-page'
        // exact: true
    },
    // TODO remove this after Tr2 decom
    // Routes included in progress stepper
    confirmationPage: {
        component: GaasConfirmationPage,
        title: 'Confirmation | ' + config.appTitle,
        // pageHeading: 'Confirmation',
        route: ProfileConnectRoute,
        //stepIndex: stepIndex++,
        path: '/confirmation-page'
        // exact: true
    },
    // Routes included in progress stepper
    errorPage: {
        component: AppErrorPage,
        path: '/error/:code',
        route: BaseRoute,
        exact: true,
        title: 'Error | ' + config.appTitle
    },
    unableToProcessRequestPage: {
        component: UnableToProcessRequest,
        path: '/unable-to-process-request',
        route: BaseRoute,
        exact: true,
        title: 'Unable to process your request | ' + config.appTitle
    },
    preferredNameErrorPage: {
        component: PreferredNameErrorPage,
        path: '/error-missing-preferred-name',
        route: BaseRoute,
        exact: true,
        title: 'Error | ' + config.appTitle
    },
    homePage: {
        component: LandingPage,
        path: '/',
        route: BaseRoute,
        exact: true,
    },
    landingPage: {
        component: LandingPage,
        path: '/landing-page',
        route: BaseRoute,
        exact: true,
    },
    logoutRedirect: {
        component: Logout,
        path: '/logout',
    },
    authenticateRedirect: {
        component: Authenticate,
        path: '/authenticate',
        title: 'Authentication Redirect | ' + config.appTitle
    },
    profileRedirect: {
        component: ProfileConnectRedirect,
        path: '/profile',
        title: 'Profile Redirect | ' + config.appTitle
    },
    profileRedirectSuccess: {
        component: ProfileConnectRedirect,
        path: '/profileConnectRedirect',
        title: 'Profile Connect Success | ' + config.appTitle
    },
    profileConnectError: {
        component: AppErrorPage,
        path: '/profileConnectError',
        title: 'Profile Connect Error | ' + config.appTitle
    },
    profileConnectCancel: {
        component: LandingPage,
        path: '/profileConnectCancel',
        title: 'Profile Connect Cancelled | ' + config.appTitle
    },
    poiRedirect: {
        // we don't allow this route, so consider this route an error
        component: AppErrorPage,
        path: '/poi-redirect',
        title: 'Poi Redirect | ' + config.appTitle
    },
};

export default routes;
